import { ClipboardList, FilePlus2, RefreshCw } from 'lucide-react';
import ThemeToggle from '../components/ThemeToggle';
import LanguageToggle from '../components/LanguageToggle';
import Sidebar from '../components/Sidebar';
import { useCallback, useEffect, useState } from 'react';
import AlertModal from '../components/AlertModal';
import { Navigate, Route, Routes } from 'react-router-dom';
import { apiRequest } from '../services/api';
import { useLang } from '../LangContext';
import UserFormsPage from './user/UserFormsPage';
import UserSubmissionsPage from './user/UserSubmissionsPage';

export default function UserDashboard() {
  const { locale: t } = useLang();
  const [moldTypes, setMoldTypes] = useState([]);
  const [submissions, setSubmissions] = useState([]);
  const [alert, setAlert] = useState(null);

  const loadData = useCallback(async () => {
    try {
      const [availableMoldTypes, mySubmissions] = await Promise.all([
        apiRequest('/api/moldtypes'),
        apiRequest('/api/submissions/mine'),
      ]);
      setMoldTypes(availableMoldTypes);
      setSubmissions(mySubmissions);
    } catch (exception) {
      setAlert({ type: 'error', message: exception.message });
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  async function submitForm(formId, data) {
    try {
      await apiRequest(`/api/submissions/forms/${formId}`, { method: 'POST', body: data });
      setAlert({ type: 'success', message: 'Form başarıyla gönderildi.' });
      await loadData();
      return true;
    } catch (exception) {
      setAlert({ type: 'error', message: exception.message });
      return false;
    }
  }

  // moldId'ye göre kullanıcının diline uygun (yoksa Türkçe, o da yoksa ilk uygun dil) formu çeker
  async function loadFormDetail(moldId) {
    try {
      return await apiRequest(`/api/moldtypes/${moldId}/form`);
    } catch (exception) {
      setAlert({ type: 'error', message: exception.message });
      return null;
    }
  }

  async function loadSubmission(id) {
    try {
      return await apiRequest(`/api/submissions/mine/${id}`);
    } catch (exception) {
      setAlert({ type: 'error', message: exception.message });
      return null;
    }
  }

  const pageProps = {
    moldTypes,
    submissions,
    submitForm,
    loadSubmission,
    loadFormDetail,
  };

  return (
    <div className="admin-shell">
      <Sidebar
        brand="Atunears"
        logoSrc="/logo.png"
        sections={[
          {
            label: t.sidebarUser.myForms,
            items: [
              { to: '/forms/yeni-form', label: t.sidebarUser.newForm, icon: FilePlus2 },
              { to: '/forms/gonderdiklerim', label: t.sidebarUser.sentForms, icon: ClipboardList },
            ],
          },
        ]}
      />

      <div className="admin-main">
        <header className="admin-topbar">
          <div>
            <h1>{t.topbar.userPanel}</h1>
            <p className="muted">{t.topbar.userPanelSub}</p>
          </div>
          <div className="topbar-actions">
            <LanguageToggle expanded />
            <ThemeToggle />
            <button className="btn btn-light" onClick={loadData}><RefreshCw /> {t.topbar.refresh}</button>
          </div>
        </header>

        <main className="admin-content">
          <AlertModal isOpen={Boolean(alert)} type={alert?.type || 'info'} message={alert?.message || ''} onClose={() => setAlert(null)} />
          <Routes>
            <Route index element={<Navigate to="yeni-form" replace />} />
            <Route path="yeni-form" element={<UserFormsPage {...pageProps} />} />
            <Route path="gonderdiklerim" element={<UserSubmissionsPage {...pageProps} />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}